import { render } from "./change-designated-site.vue?vue&type=template&id=5a17db70&scoped=true"
import script from "./change-designated-site.vue?vue&type=script&lang=js"
export * from "./change-designated-site.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./change-designated-site.vue?vue&type=style&index=1&id=5a17db70&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a17db70"]])

export default __exports__